import instituteSelector from 'modules/Auth/selectors'
import {
  default as instRequest,
  default as instituteRequest,
} from 'utils/instRequest'
import studentRequest from 'utils/studentRequest'
import ErrorMessage from '../../utils/ErrorMessage'
export const SET_SPECIALISATION_LIST = 'corporate/SET_SPECIALISATION_LIST'
import { systemConfig } from 'utils/config.js'
import elasticSearchRequest from 'utils/elasticSearchRequest'

// ]import authRequest from 'utils/authRequest'

export const GET_EVENT_ID = 'GET_EVENT_ID'

export const eventCreation = payload => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  let sendPayload = {
    ...payload,
    instituteCampusId: instituteCampusId,
  }
    try {
      const result = await instRequest.post(`/institutes/events`, sendPayload)
      return result
    } catch (error) {
      //console.log('Error in Event Creation =>', error)
      return error
    }
}

export const editEvent = (payload, eventId) => async (dispatch, getState) => {

    try {
      const result = await instRequest.put(
        `/institutes/events/${eventId}`,
        payload
      )
      return result
    } catch (error) {
      //console.log('Error in Event Editing =>', error)
      return error
    }
}

export const getEventByEventID =
  ({ eventId }) =>
  async (dispatch, getState) => {

      try {
        const result = await instRequest.get(`/institutes/events/${eventId}`)
        dispatch({ type: GET_EVENT_ID, payload: result?.data?.data })
        return result
      } catch (error) {
        //console.log('Error in getting Event By Event ID =>', error)
        return error
      }
  }

export const getListofEventsForCollege =
data => async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const category = data?.category?.length > 0 ? `&category=${data?.category}` : ''
    const year = data?.year?.length > 0 ? `&yearOfPassing=${data?.year}` : ''
    const degree = data?.degree?.length > 0 ? `&degreeId=${data?.degree}` : ''
     const department = data?.department?.length > 0 ? `&streamId=${data?.department}` : ''
    const search = data?.search && `&search=${encodeURIComponent(data?.search)}`
    // const sort = data?.sort && `&sort=${data?.sort}`
    const isCalender = data?.forCalendar
   const forRegisterEvent =  data?.forRegisterEvent ?  `&forRegisterEvent=true` : ''
   const forRecentlyAdded = data?.forRecentlyAdded ? `&forRecentlyAdded=true&sort=createdAt&order=desc` : ''
   const showAll =  data?.sort === "showAll" ? `&sort=createdAt&order=desc` : ''
   const dateWise =  data?.sort === "dateWise" ? `&sort=createdAt&order=asc` : ''
   
      try {
        let result
        if(isCalender)
        {
         result = await instRequest.get(
          `/institutes/events/instituteCampus/${institute_id}/list?forCalendar=true&status=1`
        )
        }
     
        else{
          if(data?.eventStatus === "DRAFT")
          {
            result = await instRequest.get(
              `/institutes/events/instituteCampus/${institute_id}/list?${search}&status=0&sort=createdAt&order=desc`
            )
          }
          else
          {
          result = await instRequest.get(
            `/institutes/events/instituteCampus/${institute_id}/list?pageLimit=${data?.pageLimit}&pageNo=${data?.pageNo}${search}${forRegisterEvent}${forRecentlyAdded}${showAll}${dateWise}&from=${data?.from}${category}&occurence=${data?.occurence}&forCalendar=${data?.forCalendar}${year}${department}${degree}`
          )
          }
        }
        return result?.data?.data
      } catch (error) {
        //console.log('Error in getListofEventsForCollege =>', error)
        return error
      }
  }


export const getListOfEventsForStudent = data => async (dispatch, getState) => {
  try {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const result = await instRequest.get(
      `/institutes/events/instituteCampus/${institute_id}/list?status=1`
    )
    return result
  } catch (error) {
    //
  }
}

export const getEligibilityCriteria =
  ({ searchValue = '', searchType = 'ALL', searchField = [], degreeId = '', departmentId = '' }) =>
  async (dispatch, getState) => {

     const state = getState()
     const institute_id = instituteSelector.getInstituteDetails(state).id
     let filters = [
   
      {
        type: 'terms',
        field: 'instituteCampuseId',
        value: [
          institute_id
        ],
      },
      degreeId &&  {
        "type": "terms",
        "field": "degreeId.keyword",
        "value": [
          degreeId
        ]
    } ,
    departmentId &&  {
      "type": "terms",
      "field": "streamId.keyword",
      "value": [
        departmentId
      ]
  } ,
  (searchType === "DEGREE" || searchType === "STREAM" || searchType === "ALL") && {
    field: "courseStatus",
    value: 1
  }
    ].filter(Boolean);

let output = [];

if (searchField?.length > 0) {
  // "DIPLOMA" is a TPO-facing bucket that also covers PG-diploma degrees (e.g. PGDM),
  // which are stored with type P_G_DIPLOMA (mirrors RolePage/JobRoles eligibility search).
  output = searchField?.flatMap(value =>
    value === 'DIPLOMA'
      ? [{ field: "type.keyword", value: 'DIPLOMA' }, { field: "type.keyword", value: 'P_G_DIPLOMA' }]
      : [{ field: "type.keyword", value }]
  );
}
    if(searchValue && searchType=="STREAM" || searchType=="SPECIALISATION" ){
      searchValue = searchValue.toLowerCase()
    }
    let payLoad = systemConfig?.degree_streams_specialisation_course
    payLoad.q = searchValue || ''
    payLoad.searchType = searchType
    payLoad.filters = filters
    payLoad.should = output

    try {
      const result = await elasticSearchRequest.post(
        `/search/degrees/streams/specialisations/events`,
        payLoad
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
     
  }
export const updateEventStatus =
  ({ eventId, payload }) =>
  async (dispatch, getState) => {

    
      try {
        const result = await instRequest.put(
          `/institutes/events/${eventId}/status`,
          payload
        )
        return result
      } catch (error) {
        //console.log('Error in getting Event By Event ID =>', error)
        return error
      }
  }
export const duplicateEvent =
  ({ eventId }) =>
  async (dispatch, getState) => {

      try {
        const result = await instRequest.post(
          `/institutes/events/${eventId}/duplicate`
        )
        return result
      } catch (error) {
        //console.log('Error in Event Editing =>', error)
        return error
      }
  }
export const deleteEvent =
  ({ eventId }) =>
  async (dispatch, getState) => {

      try {
        const result = await instRequest.delete(`/institutes/events/${eventId}`)
        return result 
      } catch (error) {
        //console.log('Error in Event delete =>', error)
        return error
      }
  }
export const setSpecialisationList = data => {
  return {
    type: SET_SPECIALISATION_LIST,
    data,
  }
}

export const getSpecialisationList = payload => async (dispatch, getState) => {
  try {
    const result = await instituteRequest.post(
      `/institutes/specialitationList`,
      payload
    )
    dispatch(setSpecialisationList(result?.data?.data || []))
    return result
  } catch (error) {
    //console.log('Error in getting a list of specialisation =>', error?.message)
    ErrorMessage(error?.message)
    return error?.response
  }
}

export const bulkUploadForEvents =
  (payload, eventId) => async (dispatch, getState) => {
    const state = getState()
    // eslint-disable-next-line no-useless-catch
    try {
      const instituteCampusId = instituteSelector.getInstituteDetails(state).id

      const result = await studentRequest.post(
        `students/event/${eventId}/instituteCampus/${instituteCampusId}/bulkUpload`,
        payload
      )
      // SuccessMessage(result?.data?.message)
      return result
    } catch (error) {
      // ErrorMessage(error?.response?.data?.message)
      throw error
    }
  }

export const resolveConflict =
  (eventId, pageSize, searchBy) => async (dispatch, getState) => {
    const state = getState()
    try {
      const instituteCampusId = instituteSelector.getInstituteDetails(state).id

      const search = searchBy !== '' ? `&search=${searchBy}` : ''
      const result = await instRequest.get(
        `/institutes/instituteCampus/${instituteCampusId}/event/${eventId}/conflict/candidates?pageLimit=10&pageNo=${pageSize}${search}`
      )

      return result?.data?.data
    } catch (error) {
      console.error(error)
      ErrorMessage(error?.message)
    }
  }


  export const getListofEventsFiltersForCollege =
data => async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
 
      try {
        let result
    
         result = await instRequest.get(
          `/institutes/eventsFilter/instituteCampus/${institute_id}/list`
        )
        
       
        
        return result?.data?.data
      } catch (error) {
        //console.log('Error in getListofEventsForCollege =>', error)
        return error
      }
    
  }
 